import { useEffect,useState } from "react"
import axios from "axios"
export default function DelProyecto({clientes,centros,proyectos,setProyectos}){
    const [error,setError]=useState(false)
    const [acierto,setAcierto]=useState(false)
    const [id_cliente,setIdCliente]=useState(clientes.filter(cliente=>centros.filter(centro=>proyectos.find(proyecto=>proyecto.id_centro==centro.id)!=null).find(centro=>centro.id_cliente==cliente.id)!=null)[0].id)
    const [id_centro,setIdCentro]=useState(centros.filter(centro=>proyectos.find(proyecto=>proyecto.id_centro==centro.id)!=null)[0].id)
    const [id,setId]=useState(proyectos.filter(x=>x.id_centro==centros.filter(centro=>proyectos.find(proyecto=>proyecto.id_centro==centro.id)!=null)[0].id).sort((x,y)=>x.nombre.localeCompare(y.nombre))[0].id)
    const [mensaje,setMensaje]=useState("")
    useEffect(()=>{
        
    },[])
    function formatStringReverse(str){
        const d=new Date(str)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    const Click=()=>{
        axios.delete(`https://www.asinova.es/webapi/api/Proyectos/${id}`).then(()=>{
            setProyectos(proyectos.filter(x=>x.id!=id).sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))));
            setAcierto(true)})
    }
    const onChange=(event)=>{
        setAcierto(false)
    }
    return (
        <div>
            <h1 style={{textAlign:'center'}}>ELIMINAR PROYECTO</h1>
            <div className="formulario-vertical"  style={error?null:{marginBottom:'1rem'}}>
                <select name="cliente" id="cliente" onChange={(e)=>{setIdCliente(e.target.value);setIdCentro(centros.find(x=>x.id_cliente==e.target.value).id);setId(proyectos.sort((x,y)=>x.nombre.localeCompare(y.nombre)).find(y=>centros.find(x=>x.id_cliente==e.target.value).id==y.id_centro).id)}}>
                    {
                        clientes.filter(cliente=>centros.filter(centro=>proyectos.find(proyecto=>proyecto.id_centro==centro.id)!=null).find(centro=>centro.id_cliente==cliente.id)!=null).map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
                <select name="centro" id="centro" value={id_centro} onChange={(e)=>{setIdCentro(e.target.value);setId(proyectos.sort((x,y)=>x.nombre.localeCompare(y.nombre)).find(x=>x.id_centro==e.target.value).id)}}>
                    {
                        centros.filter(centro=>proyectos.find(proyecto=>proyecto.id_centro==centro.id)!=null).filter(x=>x.id_cliente==id_cliente).map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
                <select name="proyecto" id="proyecto" value={id} onChange={(e)=>{setId(e.target.value)}}>
                    {
                        proyectos.filter(x=>x.id_centro==id_centro).sort((x,y)=>x.nombre.localeCompare(y.nombre)).map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
            </div>
            {acierto?<p className="aqua" style={{textAlign:'center'}}><b>Proyecto eliminado con éxito</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Enviar</a>
        </div>
    )
}